// extracted by mini-css-extract-plugin
export default {"button":"DashButton_button__KDDfz","opacityButton":"DashButton_opacityButton__x6JhD"};